import type { Degree } from "@pdfking/math"
import { RotateMarginsLeft, Total } from "@pdfking/math"
import { QUARTER_TURN, ZERO_DEGREE } from "@pdfking/math/constants"

import type { Layout } from "../types/layout"
import { QuarterTurn } from "./TurnMargins"

// One quarter counter-clockwise. The tree lists its children top to bottom and
// left to right, so a row stood up lists its first child last — it is now the
// bottom one — while a column laid down keeps its order.
const quarter = <D>(layout: Layout<D>): Layout<D> => {
  const rotation = QuarterTurn(Total(layout.rotation ?? ZERO_DEGREE, QUARTER_TURN))
  if (layout.enum === "page") return { ...layout, rotation }
  const layouts = (layout.layouts ?? []).map(quarter)
  const row = (layout.direction ?? "row") === "row"
  return {
    ...layout,
    direction: row ? "column" : "row",
    layouts: row ? layouts.reverse() : layouts,
    padding: layout.padding && RotateMarginsLeft(layout.padding),
    rotation,
    size: layout.size && { height: layout.size.width, width: layout.size.height },
  }
}

/** The layout turned `rotation` counter-clockwise, in quarters. */
export const RotateLayout = <D>(layout: Layout<D>, rotation: Degree): Layout<D> => {
  let turned = layout
  for (let i = 0; i < QuarterTurn(rotation) / QUARTER_TURN; i++) turned = quarter(turned)
  return turned
}
